import { RouteInfoContext } from "@/components/context-providers/RouteInfoProvider";
import { ChalkLink } from "@/components/interactive/ChalkLink";
import { formatConnectError, getQuotaSettingsHref, isDeletedUserError } from "@/utils/errors";
import { Routes } from "@/utils/routes";
import { signOutAndResetAnalytics } from "@/utils/sign-out";
import React, { useContext } from "react";

export const ConnectErrorMessage: React.FC<{ error: unknown; message?: string }> = ({
  error,
  message,
}) => {
  const route = useContext(RouteInfoContext);
  const href = getQuotaSettingsHref(error, route?.projectId, route?.environmentId);

  if (isDeletedUserError(error) || isDeletedUserError(message)) {
    return (
      <>
        Error loading data for current user. Please try{" "}
        <button
          type="button"
          className="cursor-pointer underline underline-offset-2"
          onClick={() => void signOutAndResetAnalytics({ callbackUrl: Routes.login })}
        >
          logging out
        </button>{" "}
        and trying again.
      </>
    );
  }

  return (
    <>
      {message ?? formatConnectError(error)}
      {href && (
        <>
          {" "}
          <ChalkLink href={href}>Open Quotas settings</ChalkLink>
        </>
      )}
    </>
  );
};
